export const modalEN = {
  notification_mark_to_read: 'Mark as read',
  notification_mark_to_read_for: 'Mark as read for',
  notification_mark_to_read_day: 'day',
  notification_mark_to_read_days: 'days',
}
